export const blockInvalidChar = (e: any) => ['e', 'E', '+', '-', '.', ','].includes(e.key) && e.preventDefault()

export const blockInvalidFloat = (e: any) => ['e', 'E', '+', '-', '='].includes(e.key) && e.preventDefault()
